//环境变量(dev test feat feat2 prod)
const env = process.env.REACT_APP_ENV;

//地址配置
const api = {};
const url = {};
if(env === 'dev') {
  api.gateway = '//gateway-dev.36kr.com/api';
  api.mis = '//mis-dev.corp.36kr.com/api';               //当前系统api
  api.gassist = '//assist-dev.corp.36kr.com/gapi';       //上传服务api
  api.sso = '//sso-dev.corp.36kr.com/api';
  url.mis = '//mis-dev.corp.36kr.com';                   //当前系统url
  url.sso = '//sso-dev.corp.36kr.com';                 //权限系统url
  url.mrs = '//mrs-dev.corp.36kr.com';                  //资源系统url
  url.mms = '//mms-dev.corp.36kr.com';                 //表单系统url

} else if(env === 'test') {
  api.gateway = '//gateway-test.36kr.com/api';
  api.mis = '//mis-test.corp.36kr.com/api';
  api.gassist = '//assist-test.corp.36kr.com/gapi';
  api.sso = '//sso-test.corp.36kr.com/api';
  url.mis = '//mis-test.corp.36kr.com';
  url.sso = '//sso-test.corp.36kr.com';
  url.mrs = '//mrs-test.corp.36kr.com';
  url.mms = '//mms-test.corp.36kr.com';

} else if(env === 'feat') {

  api.mis = '//mis-feat.corp.36kr.com/api';
  api.gassist = '//assist-test.corp.36kr.com/gapi';
  url.mis = '//mis-feat.corp.36kr.com';
  url.sso = '//sso-feat.corp.36kr.com';
  url.mrs = '//mrs-feat.corp.36kr.com';

} else if(env === 'feat2') {

  api.mis = '//mis-feat2.corp.36kr.com/api';
  api.gassist = '//assist-feat2.corp.36kr.com/gapi';
  url.mis = '//mis-feat2.corp.36kr.com';
  url.sso = '//sso-feat2.corp.36kr.com';
  url.mrs = '//mrs-feat2.corp.36kr.com';

} else if(env === 'pre') {
  api.gateway = '//gateway-pre.36kr.com/api';
  api.mis = '//mis-pre.corp.36kr.com/api';
  api.gassist = '//assist-pre.36kr.com/api';
  api.sso = '//sso-pre.corp.36kr.com/api';
  url.mis = '//mis-pre.corp.36kr.com';
  url.sso = '//sso-pre.corp.36kr.com';
  url.mrs = '//mrs-pre.corp.36kr.com';
  url.mms = '//mms-pre.corp.36kr.com';
  
} else if(env === 'prod') {
  api.gateway = '//gateway.36kr.com/api';
  api.mis = '//mis.corp.36kr.com/api';
  api.gassist = '//assist.36kr.com/api';
  api.sso = '//sso.corp.36kr.com/api';
  url.mis = '//mis.corp.36kr.com';
  url.sso = '//sso.corp.36kr.com';
  url.mrs = '//mrs.corp.36kr.com';
  url.mms = '//mms.corp.36kr.com';
};

export {
  api,
  url
}
